const defaultAdminFlags = {};
const adminFlags = (state = defaultAdminFlags, action) => {
  switch (action.type) {
    case 'GET_ADMIN_FLAGS_SUCCESS': {
      const { adminFlags } = action;
      return adminFlags;
    }
    default:
      return state;
  }
};

export default adminFlags;
